document.addEventListener("shipping_calculated", handleShippingCalculation);

async function estimateShippingFromCart(zip="75000", country = 'France', province = '') {
  try {
    // Get current cart data from Shopify AJAX API
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();

    if (!cartData.items || cartData.items.length === 0) {
      throw new Error('Cart is empty.');
    }

    const equipmentInCart = cartData.items.some((item) => item.product_type === "MATERIEL" || item.product_type === "ACCESS" || item.product_type === "SPARE");
    if(!equipmentInCart) return;

    // Extract variant IDs and quantities
    const items = cartData.items.map(item => ({
      variantId: item.variant_id,
      quantity: item.quantity
    }));

    console.log('Sending to /estimate-shipping:', {
      country,
      province,
      postalCode: zip,
      items
    });

    // Step 3: Send to your secure server
    const shippingRes = await fetch('https://apps.fitnessboutique.fr/estimate-shipping', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        country,
        province,
        postalCode: zip,
        items
      })
    });

    const data = await shippingRes.json();

    if (!data.success) {
      throw new Error(data.error || 'Failed to get shipping rates.');
    }

    // Step 4: Display results 
    console.log('Estimated shipping rates:', data.shipping_rates);
    const event = new CustomEvent("shipping_calculated", { detail: data.shipping_rates });
    document.dispatchEvent(event);

    return data.shipping_rates;

  } catch (err) {
    console.error('Shipping estimate failed:', err);
    const event = new CustomEvent("shipping_calculated", { detail: null });
    return [];
  }
}


function handleShippingCalculation(event) {
  console.log(event.detail);
  if(event.detail) {
    const shippingRates = event.detail;
    console.log("Shipping Rates:", shippingRates);
    const cartSubtotalContainer = document.querySelector('.cart-subtotal .cart-subtotal__amount');
    if(shippingRates.length === 1) {
      const currencySymbol = cartSubtotalContainer.getAttribute('data-cart-currency');
      const shippingPrice = parseFloat(shippingRates[0].price.amount);
      const subtotalAmount = parseFloat(cartSubtotalContainer.getAttribute('data-subtotal'));
      let newSubtotal = (shippingPrice * 100) + subtotalAmount; // convert shipping price into cents before adding
      document.getElementById('shipping_rate').innerText = shippingPrice.toFixed(2).replace('.', ',') + currencySymbol;
      newSubtotal = Shopify.formatPrice(newSubtotal, currencySymbol);
      cartSubtotalContainer.querySelector('span').innerText = newSubtotal;
      document.querySelector('.cart-drawer__shipping').classList.remove('hidden');
    } else {
      const multipleRatesMessage = document.getElementById('multiple-rates-message').innerText;
      document.getElementById('shipping_rate').innerText = multipleRatesMessage;
      document.querySelector('.cart-drawer__shipping').classList.add('hidden');
    }
  } else {
    console.log("ERROR CALCULATING SHIPPING RATES");
    document.getElementById('shipping_rate').closest('summary').style.display = 'none';
  }
}



// Estimate shipping 

document.addEventListener('on:cart-drawer:before-open', (event) => {
  estimateShippingFromCart()
});

document.addEventListener('on:cart:add', (event) => {
  estimateShippingFromCart()
});

document.addEventListener('on:line-item:change', (event) => {
  estimateShippingFromCart()
});